import { render, staticRenderFns } from "./DashboardOps.vue?vue&type=template&id=33e498bc&scoped=true"
import script from "./DashboardOps.vue?vue&type=script&lang=js"
export * from "./DashboardOps.vue?vue&type=script&lang=js"
import style0 from "./DashboardOps.vue?vue&type=style&index=0&id=33e498bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e498bc",
  null
  
)

export default component.exports